import React from "react";
import Layout from "./layout";
import AddMultiSelect from "../../../../components/AddMultiSelect";
import MultiFields from "../../../../components/AddMultiSelect/MultiFields";
import SpinnerBtn from "../../../../components/SpinnerBtn";


export default function Organization({
  handleSubmit,
  handleChange,
  formFields,
  heading,
  setEnablePage,
  handleMultiSelectChange,
  setEnableProgress,
  formValue,
  spinnerBtn
}) {
  const handleBackBtn = () =>{
    setEnableProgress(false);
    setEnablePage({
      userInfoPage: true,
      organizationInfoPage: false,
      verifyPage: false
    });
  }
  return (
    <>
    <Layout heading={heading} handleBackBtn={handleBackBtn}>
    <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
          <div className="bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12">
            <form className="space-y-6" onSubmit={handleSubmit} method="POST">
            {formFields.map((value, index) => (<><div  key={value.id} >
                <label htmlFor={value.label} className="block text-sm font-medium leading-6 text-gray-900">
                {value.label}
                </label>
                <div className="mt-2">
                  <input
                  value={formValue[value.name]}
                    name={value.name}
                    type={value.type}
                    onChange={handleChange}
                    required
                    className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                   {value.errorMsg && (<span className="text-[#dd4d4d]">{value.errorMsg}</span>)} 
                </div>
              </div>
            </>))}
            <MultiFields handleMultiSelectChange={handleMultiSelectChange}/>
            {/* <AddMultiSelect name={'defaultEnv'} label={'environment'} placeholder={"Please set environment for base url eg: 'testing' or 'production'"} handleMultiSelectChange={handleMultiSelectChange}/>
            <AddMultiSelect name={'defaultURL'} label={'baseURL'} placeholder={"Enter your full domain url"} handleMultiSelectChange={handleMultiSelectChange}/> */}

              <div>
                {!spinnerBtn ?<button
                  type="submit"
                  className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  {'save & continue'}
                </button> : <SpinnerBtn style={"w-full rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"}/>}
              </div>
            </form>
          </div>

        </div>
      {/* <form onSubmit={handleSubmit}>
        {formFields.map((value, index) => (
          <div key={value.id} className="mb-5">
            <label className="mb-2.5 block font-medium text-black dark:text-white">
              {value.label}
            </label>
            <div className="relative">
              <input
                name={value.name}
                type={value.type}
                placeholder={value.placeholder}
                onChange={handleChange}
                required
                className="w-full rounded-lg border border-stroke bg-transparent py-4 pl-6 pr-10 outline-none focus:border-primary focus-visible:shadow-none dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
              />
              {value.errorMsg && (<span className="text-[#dd4d4d]">{value.errorMsg}</span>)}
            </div>
          </div>
        ))}
        <AddMultiSelect name={'defaultEnv'} label={'environment'} placeholder={"Please set environment for base url eg: 'testing' or 'production'"} handleMultiSelectChange={handleMultiSelectChange}/>
        <AddMultiSelect name={'defaultURL'} label={'baseURL'} placeholder={"Enter your full domain url"} handleMultiSelectChange={handleMultiSelectChange}/>
        <div className="mb-5 text-center flex justify-evenly">
          <input type="submit" value="Save & Continue" className="submit-btn disabled:cursor-not-allowed disabled:opacity-75" />
        </div>
      </form> */}
    </Layout>
    </>
  );
}
